import Vue from 'vue'
import VueRouter from 'vue-router'
import { islogin } from '@utils'
import routes from './default_router'
import store from '../store'
Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('CHANGE_SPIN_STATE', true)
  if (!to.meta.needlogin) {
    next()
  } else {
    if (islogin()) {
      const role = JSON.parse(localStorage.getItem('user_type'))
      if (to.meta.role.includes(role)) {
        next()
      } else {
        next()
        // next({
        //   path:'*'
        // })
      }
    } else {
      next({
        path: '/login'
      })
    }
  }
})

router.afterEach((to, from) => {
  setTimeout(() => {
    store.commit('CHANGE_SPIN_STATE', false)
  }, 1000);
})
export default router
